import React, { useRef, useState } from "react";

import { IStringProps } from "components/dashboard/product-template-table/utils/interfaces";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from "primereact/inputtextarea";
import { T } from "services/lang/LanguageService";

export default function String(props: IStringProps) {
  const [displayModal, setDisplayModal] = useState(false);
  const [text, setText] = useState(props.value);
  const myRef = useRef<HTMLInputElement>(null);

  const onSave = () => {
    props.changeHandler(text);
    setDisplayModal(false);
  };  

  const renderFooterEditable = () => {
    return (
      <div>
        <Button label={T("action.save")} icon="pi pi-check" onClick={() => onSave()} autoFocus />
        <Button
          label={T("action.close")}
          icon="pi pi-times"
          onClick={() => setDisplayModal(false)}
          className="p-button-text"
        />
      </div>
    );
  };

  const renderFooter = () => {
    return (
      <div>
        <Button
          label={T("action.close")}
          icon="pi pi-times"
          onClick={() => setDisplayModal(false)}
          className="p-button-text"
        />
      </div>
    );
  };

  const showStart = () => {
    return `${props.value.replaceAll("<br>", "\n").substring(0, 6)}...`;
  };

  const handleClick = () => {
    if (myRef) {
      myRef.current?.focus();
    }
  };

  const buttonStyle = { padding: "7px", width: "-webkit-fill-available", margin: "4px" };

  if (props.shortenText) {
    if (props.isInEditMode) {
      return (
        <>
          <Button
            label={showStart()}
            className="p-button-sm"
            style={buttonStyle}
            icon="pi pi-comment"
            onClick={() => setDisplayModal(true)}
          />
          <Dialog
            header={T("word.message")}
            visible={displayModal}
            modal={false}
            style={{ width: "auto" }}
            footer={renderFooterEditable()}
            onHide={() => setDisplayModal(false)}
          >
            {props.selectionValues && props.selectionValues.length > 0 ? (
              <Dropdown
                style={{ width: "100%" }}
                value={props.value}
                options={props.selectionValues}
                placeholder={props.value}
                onChange={e => props.changeHandler(e.value)}
                required
              />
            ) : (
              <InputTextarea
                value={text}
                onChange={e => setText(e.target.value)}
                rows={5}
                cols={30}
                autoResize
              />
            )}
          </Dialog>
        </>
      );
    }
    const val = props.value.replaceAll("<br>", "\n");
    if (val.length === 0) return <>&#8208;</>;

    return (
      <>
        <Button
          label={showStart()}
          className="p-button-sm"
          style={buttonStyle}
          icon="pi pi-comment"
          onClick={() => setDisplayModal(true)}
        />
        <Dialog
          header={T("word.message")}
          style={{ width: "40vw" }}
          visible={displayModal}
          modal={false}
          footer={renderFooter}
          onHide={() => setDisplayModal(false)}
        >
          <div style={{ wordWrap: "break-word", whiteSpace: "pre-wrap" }}>
            {`${val} ${props.unit}`}
          </div>
        </Dialog>
      </>
    );
  }
  if (props.isInEditMode) {
    if (props.selectionValues && props.selectionValues.length > 0) {
      return (
        <Dropdown
          style={{ width: "100%", textAlign: "left" }}
          value={props.value}
          options={props.selectionValues}
          placeholder={props.value}
          onChange={e => props.changeHandler(e.value)}
          required
        />
      );
    }
    return (
      <div
        className="p-inputtext p-d-flex p-jc-between"
        style={{ padding: "0" }}
        onClick={handleClick}
      >
        <input
          ref={myRef}
          className="p-inputtext"
          style={{ border: "none", float: "left", width: "100%" }}
          value={props.value}
          onChange={e => props.changeHandler(e.target.value)}
        />
        {props.unit && props.unit.replaceAll(" ", "") && (
          <label style={{ padding: "12px" }}>{` ${props.unit}`}</label>
        )}
      </div>
    );
  }
  return (
    <div
      className="p-inputtext"
      style={{
        border: "none",
        backgroundColor: "inherit",
        color: "inherit",
        whiteSpace: "pre-wrap",
      }}
    >
      {!props.value && !props.unit && <>&#8208;</>}
      {`${props.value} ${props.unit}`}
    </div>
  );
}
